import {
  VehicleInsuranceSearchFormValues,
  VehicleInsuranceEditFormValues,
  VehicleInsuranceDetailFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
CALCULATION SETTING - VEHICLE INSURANCE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialVehicleInsuranceSearchForm: VehicleInsuranceSearchFormValues =
  {
    search: "",
  };

/*-------------------------------------------------------------------------------------------
CALCULATION SETTING - VEHICLE INSURANCE EDIT
---------------------------------------------------------------------------------------------*/
export const initialVehicleInsuranceEditForm: VehicleInsuranceEditFormValues = {
  fromKw: null,
  toKw: null,
  price: null,
};

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - VEHICLE INSURANCE - DETAIL
---------------------------------------------------------------------------------------------*/

export const initialVehicleInsuranceDetailForm: VehicleInsuranceDetailFormValues =
  {
    id: null,
    fromKw: null,
    toKw: null,
    price: null,
  };
